<template>
  <a :href="'//' + subdomain + main_domain">
    <v-sheet
      class="d-flex blue_hover"
      border
      style="height: 100%;"
    >
      <v-col cols="8" class="pa-4 d-flex flex-column">
        <div class="calc_cart__title">
          {{ `${constructionNum} ${calc.params.window_construction_name}`}}
        </div>
        <div class="calc_cart__subtitle py-2">
          На сумму <span class="calc_cart__price" > {{ calc.params.price }} </span> ₽
        </div>
        <div class="calc_cart__text">
          {{ calc.params.window_construction_casements_text }}
        </div>
        <div class="calc_cart__text">
          {{ calc.params.profile }}
        </div>
        <div v-if="calc.params.furniture" class="calc_cart__text">
          {{ calc.params.furniture.text }}
        </div>
        <div class="calc_cart__subtitle mt-auto pt-2">
          {{ `Дата:  ${constructionDate}`}}
        </div>
      </v-col>
      <v-col cols="4" class="pl-0 pr-2" >
        <img src="../../assets/poiskokna_images/def_image.png" class="calc_cart__img" title="Калькулятор пластиковых окон Поискокна" alt="Калькулятор пластиковых окон Поискокна" />
      </v-col>
    </v-sheet>
  </a>
</template>
<script>

import { mapState } from 'vuex';

export default {
  name: "Calc",
  props: ["calc"],
  computed: {
    constructionNum() {
      return `Расчет №${64730 + this.calc.id}`
    },
    constructionDate() {
			var options = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
				timezone: 'UTC'
			};
			let created_at = new Date(this.calc.created_at);
      return created_at.toLocaleString("ru", options)
    },
  },
  data() {
    return {
      main_domain,
      subdomain
    }
  },
};
</script>
